module.exports = __webpack_public_path__ + "img/link.50bf8c43.png";